import React from 'react';
export function SolutionSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-159" data-mp="324bmqbnqvd4w">
      <div className="max-w-3xl mx-auto text-center" data-id="element-160" data-mp="3aa13kaikcdv6">
        <p className="text-[20px] font-black mb-2 text-[#1B3A6B]" data-id="element-161" data-mp="3abc66709vfkp">
          La solución:
        </p>
        <h2 className="text-2xl md:text-4xl font-black mb-6 text-gray-900 leading-tight" data-id="element-162" data-mp="3oalkf14x3zm1">
          UN MATERIAL COMPLETO PARA TRABAJAR 8 HABILIDADES EN SECUNDARIA
        </h2>

        <p className="text-lg md:text-xl text-gray-700 mb-8" data-id="element-163" data-mp="139s70orffrf">
          <span className="font-bold" data-id="element-164" data-mp="3t8wxdkqieq8h">8 HABILIDADES PARA SECUNDARIA</span> reúne{' '}
          <span className="font-bold" data-id="element-165" data-mp="aue5zx2p8uko">116 páginas</span> de propuestas prácticas
          pensadas para estudiantes de 12 a 18 años.
        </p>

        <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-166" data-mp="5wm5wfrwi25e">
          {['1', '2', '3', '4', '5', '6', '7', '8'].map(n => <div key={n} className="bg-white border-2 border-[#17A2AE] text-[#1B3A6B] font-black w-12 h-12 flex items-center justify-center rounded-xl shadow-sm text-lg" data-id="element-167" data-mp="kstppezed1k5">
              {n}
            </div>)}
        </div>

        <p className="text-xl md:text-2xl font-black text-gray-900" data-id="element-168" data-mp="36cyt2jkj08qi">
          🖨️{' '}
          <span className="px-2 text-[#17A2AE] bg-white" data-id="element-169" data-mp="3bbt9jev0tl7g">
            Descargás, imprimís y aplicás.
          </span>
        </p>
      </div>
    </section>;
}